var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LPopup',[_c('h3',[_vm._v(_vm._s(_vm.locationName))]),_vm._v(" "),_c('ul',_vm._l((_vm.activities),function(activity){return _c('li',{key:activity.id},[_c('router-link',{attrs:{"to":("/activity/" + (activity.slug) + "/" + (activity.id)),"data-testid":"popupLink"}},[_vm._v("\n        "+_vm._s(activity.name)+"\n      ")])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3181e5e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActivityMarkerPopup.vue
// module id = 648
// module chunks = 0